<div class="quick-filters" (click)="$event.stopPropagation()">
    <span class="filter-label small-text-bold">Filters</span>
    <div class="filter-chip" *ngFor="let filter of filters"
        [ngClass]="{ 'filter-chip-active': isSelected(filter.key), 'filter-chip-disabled': disabled }"
        (click)="toggleFilter(filter.key); $event.stopPropagation();">
        <div class="filter-chip-icon-container">
            <img class="filter-chip-icon" [src]="filter.icon" alt="">
        </div>
        
        <span class="filter-chip-label small-text">{{filter.label}}</span>
    </div>
</div>
